import LogoCard from "@/components/logo-card"
import ImageBox from "@/components/image-box"
import { langStore } from "@/stores/lang-store"
import Header from "@/routes/_layout/header"
import useIsMobile from "@/hooks/use-is-mobile"
import { selectBundle } from "./select-const"

const SelectPage = () => {
  const isMobile = useIsMobile()
  const mode = isMobile ? "mobile" : "desktop"

  const { lang } = langStore()

  const HeaderComponent = Header.default[mode]

  return (
    <main className="min-h-screen w-full bg-slate-50 flex flex-col relative">
      <HeaderComponent />

      <div className="flex-1 flex flex-col items-center md:justify-center px-4 pt-10 md:pt-0">
        {/* 타이틀 섹션 */}
        <div className="text-center mb-6 md:mb-32">
          <div className="flex items-center justify-center gap-3 mb-4">
            <ImageBox className="w-12 md:w-16" src={"/images/toicos-logo-a.png"} />
            <span className="bg-blue-100 text-blue-800 text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide">
              {selectBundle.discription[lang]}
            </span>
          </div>
          <h1
            className={`text-3xl md:text-5xl font-extrabold text-slate-800 tracking-tight mb-1 md:mb-3`}
          >
            {selectBundle.title[lang]}
          </h1>
          <p className="text-slate-500 text-lg">{selectBundle.subtitle[lang]}</p>
        </div>

        {/* 카드 그리드 섹션 */}
        <section className="max-w-6xl w-full grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 px-4">
          {Object.entries(selectBundle.card).map(([key, { title, description }]) => {
            const meta = selectBundle.cardMeta[key]
            const IconComponent = meta.icon
            return (
              <LogoCard
                key={key}
                customMode={true}
                path={meta.path}
                className="hover:-translate-y-2 transition-transform duration-300"
              >
                <div className="w-full h-full flex flex-col items-center justify-center py-6">
                  <IconComponent className={`w-16 h-16 md:w-20 md:h-20 ${meta.color} mb-4`} />
                  <p className="font-bold text-slate-700 text-2xl md:text-3xl">{title[lang]}</p>
                  <span className="text-slate-400 text-sm mt-2 font-medium">
                    {description[lang]}
                  </span>
                </div>
              </LogoCard>
            )
          })}
        </section>
      </div>
    </main>
  )
}

export default SelectPage
